import React from 'react';

const IndAdjCheck = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    {...props}
  >
    <circle cx="32" cy="32" r="32" fill="#E6F1FE" />
    <path
      d="M33.3652 18.1737H24.5256C23.6366 18.1737 22.7841 18.5269 22.1555 19.1555C21.5269 19.7841 21.1737 20.6366 21.1737 21.5256V41.7304C21.1737 42.6194 21.5269 43.472 22.1555 44.1006C22.7841 44.7292 23.6366 45.0823 24.5256 45.0823H39.6792C40.5682 45.0823 41.4208 44.7292 42.0494 44.1006C42.678 43.472 43.0311 42.6194 43.0311 41.7304V22C43.0311 19.8868 41.318 18.1737 39.2048 18.1737H33.3652Z"
      stroke="#0E3054"
      strokeWidth="1.65254"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28 32.6773L32.4869 37.5908L45.6271 25"
      stroke="#E6F1FE"
      strokeWidth="3.85593"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28 32.6773L32.4869 37.5908L45.6271 25"
      stroke="#0E3054"
      strokeWidth="1.65254"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IndAdjCheck;
